<template>
  <div class="hpd-Wrapper">
    <CustomDashboardItem
      v-if="!isNil(groupId)"
      ref="customDashboardItem"
      :drag-area="dragArea"
      :group-id="groupId"
      :type="CUSTOM_DASHBOARD_ITEM_TYPES.HOMEPAGE"
      hide-actions
      hide-title
      :redirect-on-error="false"
      @elements-updated="emit('elements-updated')"
    />
    <div
      v-else
      :data-auto-testid="HOMEPAGE_DASHBOARD_EMPTY_STATE_TEST_ID"
      :data-testid="HOMEPAGE_DASHBOARD_EMPTY_STATE_TEST_ID"
      class="hpd-EmptyState"
    >
      <DashboardAccessDenied hide-back-button>
        <template #title> {{ $t('homepage.dashboard.only_for_groups') }} </template>
        <template #subtitle> {{ $t('homepage.dashboard.only_for_groups_subtitle') }} </template>
      </DashboardAccessDenied>
    </div>
  </div>
</template>

<script setup>
import { isNil } from 'lodash'
import { computed, inject, useTemplateRef } from 'vue'

import { CUSTOM_DASHBOARD_ITEM_TYPES } from '@/utils/custom-dashboard-helper'
import { homePageStateInjectionKey } from '@/utils/injection-keys'
import { NEW_HP_FILTERS_KEYS } from '@/utils/okr-elements/filters'

import { HOMEPAGE_DASHBOARD_EMPTY_STATE_TEST_ID } from '@/components/home-page/jest-helpers'
import CustomDashboardItem from '@/views/workspaces/_workspaceId/dashboard/customDashboardItem'
import DashboardAccessDenied from '@/views/workspaces/_workspaceId/dashboard/dashboardAccessDenied'

defineOptions({
  name: 'HomePageDashboard'
})

defineProps({
  // element in which cursor moves affect modules drag'n'drop
  dragArea: {
    type: HTMLElement,
    default: null
  }
})

const emit = defineEmits({
  'elements-updated': null
})

const homePageState = inject(homePageStateInjectionKey)
const homePageFilters = homePageState.filterValues

const groupId = computed(() => homePageFilters.value[NEW_HP_FILTERS_KEYS.SELECTED_GROUP])

const customDashboardItemRef = useTemplateRef('customDashboardItem')
const reloadDashboard = async () => {
  await customDashboardItemRef.value?.reloadDashboard()
}

defineExpose({
  reloadDashboard
})
</script>

<style lang="scss" scoped>
$body-items-gap: 16px;

.hpd-Wrapper {
  --ob-cdi-page-top-padding: 0;
  --ob-cdi-page-right-padding: 0;
  --ob-cdi-page-left-padding: 0;
  --ob-dil-page-right-padding: 0;
  --ob-cdi-header-margin-bottom: #{$body-items-gap};
  --ob-cdi-page-background: none;
  --ob-dil-header-margin-bottom: #{$body-items-gap};

  padding-top: $body-items-gap;
}

.hpd-EmptyState {
  width: 100%;
  border-radius: $border-radius-lg;
  background: $white;
  border: 1px solid $grey-2-next;
}
</style>
